import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const StatBox = ({ title, subtitle, icon, progress, increase, titleProps, subtitleProps }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // 0원, 0건 여부에 따라 색상 결정
  const getSubtitleColor = () => {
    if (subtitle === "0.0 원" || subtitle === "0건" || subtitle === "0명") {
      return "#f87171";  // 0인 경우 빨간색
    }
    return "#4ade80";  // 0이 아닌 경우 녹색
  };

  return (
    <Box width="100%" m="0 15px" display="flex" justifyContent="space-between" alignItems={'center'}>
      <Box>
        {icon}
        <Typography
          variant="h5"
          fontWeight="600"
          sx={{ 
            color: "#ffffff",
            fontSize: "16px",
            mt: 1,
            ...(titleProps?.sx || {})
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Typography 
          variant="h5" 
          fontWeight="700"
          sx={{ 
            color: getSubtitleColor(),
            fontSize: "18px",
            ...(subtitleProps?.sx || {})
          }}
        >
          {subtitle}
        </Typography>
        {increase && (
          <Typography
            variant="h5"
            fontStyle="italic"
            sx={{ 
              color: "#ffffff",
              ml: 1
            }}
          >
            {increase}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StatBox;